import debounce from 'lodash/debounce';
import React, { memo, useEffect, useState } from 'react';
import ReactPlayer from 'react-player/file';
import { usePrevious } from 'react-use';

import { VideoPlayerWrapper } from './styled';

type Props = {
  src: string;
  className?: string;
  hideControl?: boolean;
};

const VideoPlayer = ({ src, className, hideControl = false }: Props): JSX.Element => {
  const [videoSource, setVideoSource] = useState('');
  const prevValue = usePrevious(src);

  useEffect(() => {
    if (src === prevValue) return;

    const debouncedFetchMediaSources = debounce(() => {
      setVideoSource(src);
    }, 300);

    debouncedFetchMediaSources();

    return () => {
      debouncedFetchMediaSources.cancel();
    };
  }, [hideControl, prevValue, src]);

  return (
    <VideoPlayerWrapper className={className} data-testid="video-player">
      <ReactPlayer url={videoSource} playing={false} controls={!hideControl} />
    </VideoPlayerWrapper>
  );
};

export default memo(VideoPlayer);
